var global_helpers = {

    defaults: {
        breakpoint_desktop: 960,
    },

    settings: {},

    init: function () {
        this.bindUIActions();
    },

    bindUIActions: function () {
    },

    // Returns a function that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If 'immediate' is passed, trigger the function on the
    // leading edge, instead of the trailing.
    //
    // Use:  $(window).resize(global_helpers.debounce(function() { ...[your code here]... }, 500));
    // Source:  http://davidwalsh.name/javascript-debounce-function
    debounce: function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) { func.apply(context, args); }
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) { func.apply(context, args); }
        };
    },

}
global_helpers.init();